<template>

  <el-dialog custom-class="list-dialog" title="维护证书" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="5">
          <el-radio-group v-model="certtype"  @change="bindGrid" size="mini">
          <el-radio-button :label="'1'" :key="'1'">产品证书</el-radio-button>
          <el-radio-button :label="'2'" :key="'2'">企业证书</el-radio-button>
        </el-radio-group>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请选择商品" v-model="seedname" clearable @click.native="showGoodDetailSel"
                                      @clear="clearSeedCode" v-if="certtype=='1'" size="mini">
        </el-input>
          <AutoCustomer :unitgroup="''" @clear="clearPcustomer" @handleSelect="afterSelPcustomer"
                        placeholder="搜索，enter键结束" v-if="certtype=='2'" :size="'mini'"></AutoCustomer>
        </el-col>
        <el-col :span="10">
          <!--<el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid">搜索</el-button>-->
          <el-button type="warning" v-on:click="add" size="mini">新增</el-button>
          <certEdit ref="DataContactEdit" @bindGrid="bindGrid"></certEdit>
          <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
          <el-checkbox v-model="checkExceedtime" v-if="exceedtime" style="color: red" @change="bindGrid">{{exceedtime}}</el-checkbox>
        </el-col>

      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="tableHeight(160)"
      size="mini"
      stripe
      border
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编号"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="showname"
        label="名称"
        header-align="center"
        align="left">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="certname"-->
        <!--label="名称"-->
        <!--header-align="center"-->
        <!--align="left">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="certno"
        label="证号"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="certorg"
        label="企业名称"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="model"
        label="规格型号"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="sendtime"
        label="发证日期"
        header-align="center" width="100"
        align="left">
        <template slot-scope="scope">
          {{(scope.row.sendtime || "").substr(0, 10)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="endtime"
        label="有效期"
        header-align="center" width="120"
        align="left">
        <template slot-scope="scope">
          {{(scope.row.endtime || "").substr(0, 10)}}<span style="color: red">{{getChaoQi(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
  </el-dialog>
</template>

<script>
  import certEdit from './certEdit';
  import {getListData, deleteData} from '@/api/set/certmanage'
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: 'certList',
    data() {
      return {
        msg: '证书管理',
        searchdata: "",
        checkExceedtime:false,
        dialogFormVisible:false,
        loading: true,
        exceedtime:'',
        certtype:'1',
        seedname:'',
        seedcode:'',
        pcustomer:'',
        pcustomerserial:'',
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: []
      }
    },
    methods: {
      getChaoQi(row){
        if(new Date(row.endtime)<new Date()){
          return '过期';
        }
        return '';
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.bindGrid()
      },
      show() {
        this.dialogFormVisible=true;
        this.bindGrid();
      },
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.bindGrid()
      },
      clearPcustomer() {
        // this.isClickEvent = false
        this.pcustomer = ""
        this.pcustomerserial = ""
        this.bindGrid()
      },
      //查询条件的供应商之后执行
      afterSelPcustomer(customerserial, customername, row) {
        this.pcustomer = customername
        this.pcustomerserial = customerserial
        this.bindGrid()
      },
      //跳转编辑页面
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid)
      },
      handleDelete(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({unitguid: row.unitguid}).then(response => {
            this.bindGrid();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showExceed(){

      },
      //绑定分页参数
      bindGrid() {
        this.exceedtime='';
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          certtype: this.certtype,
          seedcode: this.certtype == '1' ? this.seedcode : '',
          customerserial: this.certtype == '2' ? this.customerserial : '',
          exceedtime:this.checkExceedtime?'true':''
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
          if(response.data.exceedtime>0){
            this.exceedtime='失效证书：'+response.data.exceedtime;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      add() {
        this.$refs.DataContactEdit.add(this.certtype)
        this.$refs.DataContactEdit.initForm()
      },
    },
    mounted() {
      // this.bindGrid();
    },
    components: {
      certEdit,
      JxcgooddetailSel,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/cert/certList.vue